import { useMap, useMapEvents } from "react-leaflet";

function MyComponent({ setPosition }) {
  useMapEvents({
    click: (e) => {
      // const lat = e.features[0].properties
      const lat = e.latlng.lat;
      const lng = e.latlng.lng;
      if (lat > 180 || lat < -180) return;
      if (lng > 180 || lng < -180) return;
      setPosition({ lat, lng });
    },
  });
  return null;
}

export default MyComponent;
